define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare, Controller) {

	return declare(Controller, {
		postProcessSuccess() {
			return this.widget.suspendView(!!this.actionValue);
		}
	});
});